export const columns = [
  {
    type: "link",
    name: "orderNumber",
    label: "Order Number",
    searchable: true,
    style: { width: "15rem" },
    show: true
  },
  {
    type: "multi_select",
    name: "courier_name",
    label: "Courier",
    style: { width: "15rem" },
    show: true,
    searchable: true
  },
  {
    type: "multi_select",
    name: "merchant_name",
    label: "Merchant",
    style: { width: "15rem" },
    show: true,
    searchable: true
  },
  {
    type: "string",
    name: "displayedStatus",
    label: "Status",
    style: { width: "15rem" },
    show: true
  },
  {
    type: "multi_select",
    name: "status",
    label: "Status",
    searchable: true,
    options: [],
    style: { width: "15rem" },
    show: false
  },
  {
    type: "date_range",
    name: "creation_date",
    label: "Created At",
    style: { width: "15rem" },
    show: true
  },
  {
    type: "string",
    name: "employee",
    label: "Employee",
    searchable: true,
    style: { width: "15rem" },
    show: true
  },
  {
    type: "string",
    name: "note",
    label: "Note",
    style: { width: "15rem" },
    show: true
  },
  {
    type: "date_range",
    name: "resolved_date",
    label: "Resolved Date",
    style: { width: "15rem" },
    show: true
  },
  {
    type: "link",
    name: "proof_image",
    label: "Proof Image",
    searchable: false,
    style: { width: "15rem" },
    show: true
  },
  {
    name: "actions",
    label: "",
    type: "actions",
    style: { width: "3rem" },
    searchable: false,
    stickyRight: true,
    show: true
  },
]; 